import { Navigate } from "react-router-dom"
import { rootStore } from "stores/root-store"

const ProtectedRoute = ({ redirectPath = "/", children }) => {
  if (!rootStore.isAuthenticated) {
    return <Navigate to={redirectPath} replace />
  }

  return children
}

export default ProtectedRoute
